import { render, staticRenderFns } from "./ButtonBulk.vue?vue&type=template&id=5645067d&scoped=true"
import script from "./ButtonBulk.vue?vue&type=script&lang=js"
export * from "./ButtonBulk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5645067d",
  null
  
)

export default component.exports